import { apiErrorHandler } from './../../errors/api-error-handler';
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import SliderService from "../../services/slider.service"
import { SliderInitialStateType, SliderType } from '../../models/slider.model';

const initialState: SliderInitialStateType = {
    SliderData: [],
    SliderPhiladelphiaData: [],
    SliderLoading: true,  
    SliderError: undefined,
} ;

export const retrieveSlider = createAsyncThunk('Slider/retrieve',
    async (path: string, { rejectWithValue }) => {
        try {
            const response = await SliderService.getAllSlider(path)
         return [response.data]
         
        } catch (error: any) {
            if (!error.response) {
                throw error
              }
            return rejectWithValue(error.response.status)
            
        }
        
    }
)



const Slider = createSlice({
    name: 'Slider',
    initialState: initialState,
    reducers: {


    },
    extraReducers: (builder) => {
        builder
            .addCase(retrieveSlider.pending, (state) => {
                    state.SliderLoading = true;
            })
            .addCase(retrieveSlider.fulfilled, (state, action) => {
                if(action.payload){
                    state.SliderLoading = false;
                    state.SliderData = action.payload as SliderType[];
                }   
            })        
            .addCase(retrieveSlider.rejected, (state, {payload}) => {
                    state.SliderLoading = false;
                    state.SliderError = apiErrorHandler(Number(payload))
            })
    }
})

export const selectAllEntities = (state: { entities: any; }) => state.entities;
export default Slider.reducer;
